// extracted by mini-css-extract-plugin
export default {"paginationPageDropdownWrap":"Orders_paginationPageDropdownWrap__sjWA+","tabWrapper":"Orders_tabWrapper__f229p"};